import { render, staticRenderFns } from "./WritSendDate.vue?vue&type=template&id=2d189d5c&scoped=true"
import script from "./WritSendDate.vue?vue&type=script&lang=js"
export * from "./WritSendDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d189d5c",
  null
  
)

export default component.exports